import React, { useMemo } from 'react';

import { type IMergedSlot } from '../../../interface/pu-events';
import { deriveCompletionSummary, formatDuration } from '../../../lib/duration';

/**
 * Day-summary strip shown once all 8 milestones are captured: how long the
 * election day ran end-to-end, and the voting / counting phase durations.
 */
const PulseSummary = ({ slots }: { slots: IMergedSlot[] }) => {
	const summary = useMemo(() => deriveCompletionSummary(slots), [slots]);

	const stats: { label: string; ms: number | null }[] = [
		{ label: 'Day span', ms: summary.totalSpanMs },
		{ label: 'Voting', ms: summary.votingMs },
		{ label: 'Counting', ms: summary.countingMs },
	];

	return (
		<section
			className='pue-summary'
			aria-label='Election day summary'
		>
			<p className='pue-summary__title'>All 8 milestones captured</p>
			<div className='pue-summary__stats'>
				{stats.map((stat) => (
					<div
						key={stat.label}
						className='pue-summary__stat'
					>
						<span className='pue-summary__stat-value'>{stat.ms !== null && stat.ms >= 0 ? formatDuration(stat.ms) : '—'}</span>
						<span className='pue-summary__stat-label'>{stat.label}</span>
					</div>
				))}
			</div>
		</section>
	);
};

export default PulseSummary;
